import React from 'react'
import { FaHeart, FaRegHeart } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import styles from './EachProduct.module.css'

const EachProduct = (props) => {
    const { item, inWishlist, toggleWishlistItem } = props

    return (
        
        <div className={styles.eachItemWrapper}>
                <Link to={`/catalogue/product/${item?.productIdentifier}`}>
                <div className={styles.thumbnail} >
                    <img src={item?.image_urls} />
                    {/* {inWishlist === true ?
                    <div className={styles.wishlistIconAdded} onClick={() => toggleWishlistItem(item?.id)}>
                    <FaHeart size={22} color="#9524A3" />
                    </div>
                    :
                    <div className={styles.wishlistIcon}>
                    <FaRegHeart size={22} color="#dfdfdf" onClick={() => toggleWishlistItem(item?.id)} />
                    </div>
                } */}
                </div>
                <div className={styles.title}>
                    {item?.productTitle}
                </div>
                <div className={styles.brand}>
                    {item?.categoryLabel}
                </div>
                <div className={styles.categoryWrapper}>
                    <div className={styles.category}>
                        ₹{item?.offeredPrice}
                    </div>
                </div>
        </Link>
            </div>
    )
}

export default EachProduct